var _g, _path, _path2, _g2, _path3, _path4, _path5, _g3, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgForTranslators = function SvgForTranslators(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 236,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#for_translators_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 123.481,
    height: 123.481,
    fill: "#51C394",
    rx: 32.495,
    transform: "matrix(-1 0 0 1 219.455 48.03)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.827 109.264c-4.356 4.356-11.444 4.356-15.8 0a5.92 5.92 0 0 1 0-8.365l11.531-11.53q.455-.455.938-.869h-25.524A1.97 1.97 0 0 0 124 90.472v23.979c0 1.089.883 1.972 1.972 1.972h10.056l15.58 15.579c2.508 2.508 6.2 3.127 9.294 1.858l-7.435-7.434a1.972 1.972 0 0 1 2.788-2.789l7.9 7.9 3.718-3.717-7.9-7.9a1.972 1.972 0 0 1 2.788-2.789l7.9 7.901 3.718-3.718-15.801-15.801z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M189.328 88.5h-27.152c-3.335 0-6.47 1.299-8.829 3.657l-11.531 11.531c-.77.77-.77 2.018 0 2.788a7.23 7.23 0 0 0 10.224 0l5.316-5.316a1.96 1.96 0 0 1 2.401-.3c2.374 1.457 5.699 1.494 7.652-.459a1.972 1.972 0 0 1 2.788 2.789c-1.531 1.53-3.573 2.414-5.743 2.622l12.714 12.714 2.103-2.103h10.057a1.97 1.97 0 0 0 1.971-1.972v-23.98a1.97 1.97 0 0 0-1.971-1.971"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#for_translators_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.493,
    height: 45.493,
    fill: "#3B7CC9",
    rx: 11.698,
    transform: "matrix(-1 0 0 1 249.508 35.275)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F3FF",
    fillRule: "evenodd",
    d: "M214.558 55.794c0-.812.697-1.47 1.556-1.47h9.341c.859 0 1.556.658 1.556 1.47s-.697 1.47-1.556 1.47h-9.341c-.859 0-1.556-.658-1.556-1.47",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3F3FF",
    fillRule: "evenodd",
    d: "M220.784 45.5c.59 0 1.129.315 1.392.813l6.227 11.764c.385.727.073 1.61-.696 1.973-.769.364-1.704.07-2.089-.657l-4.834-9.134-4.835 9.134c-.384.726-1.319 1.02-2.088.657s-1.081-1.246-.696-1.973l6.227-11.764c.263-.498.802-.813 1.392-.813",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M231.681 51.382c0 .812.697 1.47 1.556 1.47s1.557-.658 1.557-1.47v-2.94c0-.813-.697-1.471-1.557-1.471h-3.113c-.86 0-1.557.658-1.557 1.47s.697 1.47 1.557 1.47h1.557zm0 5.883v-1.471c0-.813.697-1.471 1.557-1.471.859 0 1.556.658 1.556 1.47v1.472h4.67c.86 0 1.557.658 1.557 1.47s-.697 1.47-1.557 1.47h-1.443c-.035 2.197-.851 4.44-2.408 6.273 1.098.579 2.421.97 3.974 1.085.857.064 1.497.772 1.43 1.581-.067.81-.817 1.415-1.674 1.351-2.431-.18-4.472-.892-6.105-1.944-1.634 1.052-3.674 1.764-6.106 1.944-.857.064-1.606-.54-1.674-1.35s.573-1.518 1.43-1.582c1.553-.115 2.877-.506 3.975-1.085-1.557-1.833-2.373-4.076-2.408-6.272h-1.445c-.86 0-1.556-.659-1.556-1.47 0-.813.696-1.471 1.556-1.471h4.671m1.557 7.308c1.085-1.3 1.638-2.863 1.67-4.367h-3.34c.032 1.504.585 3.067 1.67 4.367m-12.454-4.368c.86 0 1.557.659 1.557 1.47v1.471h1.557c.859 0 1.556.659 1.556 1.47 0 .813-.697 1.471-1.556 1.471h-3.114c-.859 0-1.556-.658-1.556-1.47v-2.941c0-.812.697-1.47 1.556-1.47",
    clipRule: "evenodd"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#for_translators_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.493,
    height: 45.493,
    fill: "#FFB800",
    rx: 11.698,
    transform: "matrix(-1 0 0 1 113.706 134.314)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M78.474 144.5h24.741a2.467 2.467 0 0 1 2.474 2.455v17.181a2.467 2.467 0 0 1-2.474 2.455h-8.661c.027.981.216 2.549.922 3.285.259.271.556.397.935.397.342 0 .619.274.619.613 0 .34-.277.614-.619.614H85.278a.616.616 0 0 1-.619-.614c0-.339.277-.613.619-.613.38 0 .676-.127.936-.398.708-.739.896-2.305.922-3.284h-8.662A2.467 2.467 0 0 1 76 164.136v-17.181a2.467 2.467 0 0 1 2.474-2.455m0 2.455v15.617h24.634l-.001-15.617zm11.725 2.708h-9.036v10.327H90.2zm1.291 0h9.036v3.873H91.49zm9.036 5.164H91.49v5.163h9.036z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2FFEA",
    d: "M89.551 52.827c-.96 3.624-4.665 5.78-8.278 4.817s-5.764-4.68-4.804-8.304 4.667-5.781 8.28-4.818c3.613.962 5.762 4.68 4.802 8.305M250.287 158.476c-.96 3.624-4.666 5.78-8.278 4.817s-5.764-4.68-4.804-8.304 4.667-5.782 8.279-4.819 5.762 4.682 4.803 8.306"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "for_translators_svg__a",
    width: 214.468,
    height: 214.467,
    x: 53.08,
    y: 12.935,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.6,
    dy: 10.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.747
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9013_146876"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9013_146876",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "for_translators_svg__b",
    width: 136.479,
    height: 136.479,
    x: 161.121,
    y: 0.18,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.6,
    dy: 10.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.747
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9013_146876"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9013_146876",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "for_translators_svg__c",
    width: 136.479,
    height: 136.479,
    x: 25.319,
    y: 99.219,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.6,
    dy: 10.398
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.747
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.351917 0 0 0 0 0.429167 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9013_146876"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_9013_146876",
    result: "shape"
  })))));
};
export default SvgForTranslators;